import { useState } from 'react';

import { CustomerListPage } from '#pages';
import { WeeklyCalendarPage } from '#pages/WeeklyCalendarPage';
import { Link, useLocation } from 'react-router-dom';

const Manage = () => {
  const { state } = useLocation();
  const [tab, setTab] = useState(state ? state : 'schedule');

  return (
    <>
      <div className="bg-[#18161C] fixed top-0 left-0 px-20 z-100 py-8 flex justify-between gap-12 items-center w-full">
        <div className="flex items-center justify-between w-full gap-12 mx-auto h-46 max-w-939">
          <div className="flex items-center gap-12">
            {TABS.map(({ label, value }) => {
              return (
                <button
                  type="button"
                  className={`font-500 text-[#D7D3DE] text-[17px] border-0 border-b-4 border-solid ${
                    tab === value
                      ? 'border-[#7750E9]'
                      : 'border-transparent text-[#8E899F ]'
                  } py-8 w-96 text-center`}
                  onClick={() => setTab(value)}
                >
                  {label}
                </button>
              );
            })}
          </div>
          <Link
            className="text-[14px] rounded-8 px-10 py-6 bg-[#7750E9] text-[#EAE8ED]"
            to={
              tab === 'schedule'
                ? '/calender/schedule-registration'
                : '/client-registration'
            }
          >
            {tab === 'schedule' ? '일정' : '회원'} 추가
          </Link>
        </div>
      </div>
      {tab === 'schedule' ? <WeeklyCalendarPage /> : <CustomerListPage />}
    </>
  );
};

export default Manage;

const TABS = [
  { label: '일정 관리', value: 'schedule' },
  { label: '회원 관리', value: 'account' }
];
